export const PERFIL_USUARIO_GET_BY_ID = "PERFIL_USUARIO_GET_BY_ID";
export const PERFIL_USUARIO_CREATE = "PERFIL_USUARIO_CREATE";
export const PERFIL_USUARIO_UPDATE = "PERFIL_USUARIO_UPDATE";
export const PERFIL_USUARIO_REMOVE = "PERFIL_USUARIO_REMOVE";
export const PERFIL_USUARIO_PLANOS_LIST = "PERFIL_USUARIO_PLANOS_LIST";
export const PERFIL_USUARIO_VINCULAR_TODOS_PLANOS =
  "PERFIL_USUARIO_VINCULAR_TODOS_PLANOS";
export const PERFIL_USUARIO_DESVINCULAR_TODOS_PLANOS =
  "PERFIL_USUARIO_DESVINCULAR_TODOS_PLANOS";
